<template>
  <div class="user-responses border-yellow">
      <User-Response-FilterBar></User-Response-FilterBar>
      <User-Response-List></User-Response-List>
      <div class="row margin-Top-5Perc ">
         <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <Copyright-Element class="footer"></Copyright-Element>
         </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>  
</template>

<script>
import UserResponseFilterBar from '@/components/UserResponsesFilterBar'
import UserResponseList from '@/components/UserResponseList'
import CopyrightElement from '@/components/CopyrightElement' // copyright Menu
import AlertBox from '@/components/AlertOverlay'
import { participantService } from '@/server-util/participant-service'
import { constants } from '@/utils/constants'
require('bootstrap/dist/css/bootstrap.min.css')
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      errorMsg: '',
      showSpinner: false
    }
  },
  components: {
    'User-Response-FilterBar': UserResponseFilterBar,
    'User-Response-List': UserResponseList,
    'Copyright-Element': CopyrightElement,
    'alert-box': AlertBox
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    }
  },
  name: 'user-responses'
}
</script>

<style scoped>
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/UserResponses.vue